export const LANDING_PAGE = 'LANDING_PAGE';
export const LANDING_PAGE_REQUEST = 'LANDING_PAGE_REQUEST';
export const LANDING_PAGE_SUCCESS = 'LANDING_PAGE_SUCCESS';
export const LANDING_PAGE_FAILURE = 'LANDING_PAGE_FAILURE';
